import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DirectivesModule } from './../directives/directives.module';
import { AdminTableActionsCellComponent } from './admin-table-actions-cell/admin-table-actions-cell.component';
import { AdminTableCellComponent } from './admin-table-cell/admin-table-cell.component';
import { AdminTableColumnComponent } from './admin-table-column/admin-table-column.component';
import { AdminTableRowComponent } from './admin-table-row/admin-table-row.component';
import { AdminTableComponent } from './admin-table.component';
import { AdminTableSortArrowsComponent } from './sort-arrows/sort-arrows.component';

@NgModule({
  declarations: [
    AdminTableComponent,
    AdminTableRowComponent,
    AdminTableColumnComponent,
    AdminTableCellComponent,
    AdminTableSortArrowsComponent,
    AdminTableActionsCellComponent
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    FontAwesomeModule
  ],
  exports: [
    AdminTableComponent,
    AdminTableRowComponent,
    AdminTableColumnComponent,
    AdminTableCellComponent,
    AdminTableSortArrowsComponent,
    AdminTableActionsCellComponent
  ]
})
export class AdminTableModule { }
